"use strict";

import loadScript from '@elements/load-script';
import {getConfigValue, requireConfigValues} from '@elements/config-utils';

export function initInScope ($scope) {

    loadScript('https://www.google.com/recaptcha/api.js?render='+ getConfigValue('recaptchaSitekey')).then(() => {
        grecaptcha.ready(function() {
            let recaptchaAction =  document.getElementById('g-recaptcha-action');
            let $form = $(recaptchaAction).closest('form');

            // check if form is valid before creating recaptcha token
            $form.find('button[type="submit"]').on('click', function(e) {
                e.preventDefault();
                e.stopImmediatePropagation();
                $(this).attr('disabled', 'true'); // disable button to prevent multiple clicks
                if ($form.parsley().validate()) {
                    // do request for recaptcha token
                    // response is promise with passed token
                    grecaptcha.execute(getConfigValue('recaptchaSitekey'), {action:recaptchaAction.value})
                        .then(function(token) {
                            // add token value to form
                            document.getElementById('g-recaptcha-response').value = token;
                            $form.submit();
                        }).
                        finally(function () {
                            $(this).removeAttr('disabled'); // enable button again after recaptcha token is created
                        });
                } else {
                    $(this).removeAttr('disabled'); // enable button again if form is not valid
                }
            });

        });
    }).catch(console.error);

}
